import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=05e4b4a9&scoped=true"
import script from "./bankList.vue?vue&type=script&lang=js"
export * from "./bankList.vue?vue&type=script&lang=js"
import style0 from "./bankList.vue?vue&type=style&index=0&id=05e4b4a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4b4a9",
  null
  
)

export default component.exports